var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.624 18.0625C30.6146 17.7182 30.5424 17.4715 30.3653 17.2767C30.0005 16.875 29.3552 16.875 28.0645 16.875H18.9355C17.6449 16.875 16.9995 16.875 16.6346 17.2767C16.2697 17.6784 16.3498 18.3006 16.5098 19.5451C16.5566 19.9086 16.6344 20.1149 16.8716 20.3969C17.6382 21.3077 19.0421 22.9278 21.0122 24.4007C21.1922 24.5352 21.3103 24.7552 21.3303 24.9986C21.5522 27.7101 21.7555 29.5623 21.8635 30.4741C21.9201 30.9524 22.4503 31.3202 22.8873 31.0112C23.6213 30.4921 24.9925 29.9103 25.1737 28.9433C25.2406 28.5864 25.3316 28.0219 25.4356 27.1667",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.625 20.0417L25.875 24.7917M30.625 24.7917L25.875 20.0417",
    stroke: "#3A86DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFilter);
export default __webpack_public_path__ + "static/media/remove-filter.e4dd745ad988baa0c54a7f3d6998c53d.svg";
export { ForwardRef as ReactComponent };